import { z } from 'zod';

const partnerDetailsSchema = z.object({
   address_1: z.string().trim().min(1, 'Address 1 is required'),
   address_2: z.string(),
   post_code: z
      .string()
      .trim()
      .min(1, 'Post code is required')
      .max(10, 'Post code must be at most 10 characters')
      .regex(/^[a-zA-Z0-9 ]+$/, 'Invalid post code'),
   phone_number: z.string().trim().min(1, 'Phone number is required'),
   nationality: z.string().trim().min(1, 'Residence is required'),
   state: z.string().trim().min(1, 'Town is required'),
   city: z.string().trim().min(1, 'City is required'),
   website: z.string().trim().min(1, 'Website is required').url('Invalid URL'),
   social_media: z.array(
      z.object({
         platform: z.string().min(1, 'Platform is required'),
         url: z.string().min(1, 'URL is required').url('Invalid URL'),
      }),
   ),
});

export type TPartnerDetails = z.infer<typeof partnerDetailsSchema>;
export { partnerDetailsSchema };

export const SOCIAL_MEDIA = {
   FACEBOOK: 'Facebook',
   X: 'X',
   INSTAGRAM: 'Instagram',
   LINKEDIN: 'LinkedIn',
} as const;
export const SOCIAL_MEDIA_VALUES = Object.values(SOCIAL_MEDIA);
export type TSOCIAL_MEDIA = (typeof SOCIAL_MEDIA)[keyof typeof SOCIAL_MEDIA];
